import EmailOTPCard from "./EmailOTPCard";

function LoginViaEmailOtp() {
  return (
    <>
      <EmailOTPCard />
    </>
  );
}

export default LoginViaEmailOtp;
